var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "-2.125 -0.25 14.5 14.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.113 3.65 6.519.15A.47.47 0 0 0 6.16 0H1.027C.462 0 0 .45 0 1v12c0 .55.462 1 1.027 1H9.24c.565 0 1.027-.45 1.027-1V4c0-.15-.052-.25-.154-.35M6.16 1.2 9.035 4H6.16zM9.24 13H1.027V1h4.106v3c0 .55.462 1 1.027 1h3.08z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.868 10.267h6.534v.933H1.868zm0-2.8h6.534V8.4H1.868zM10 4 6.5.5h-1V4l.5.5h4z"
})));
export default SvgDocs;